<template>
  <div id="user-profile">
    <profile-header />
    <section id="profile-info">
      <b-row class="flex-wrap">
        <b-col
          class="d-flex"
          lg="4"
          cols="12"
          v-for="(gradientCard, index) in gradientCards"
          :key="index"
        >
          <gradient-card :gradientCard="gradientCard" class="w-100">
            <template v-if="index == 2">
              <div class="pb-1 h3 d-flex">
                <span class="mr-50">Balance:</span>
                <b-skeleton width="80px" height="30px" v-if="loading" />
                <span class="text-info font-weight-bold" v-else>{{
                  dashboard.wallet.balance
                }}</span>
              </div>
            </template>
          </gradient-card>
        </b-col>
      </b-row>
      <b-row class="flex-column-reverse flex-md-row">
        <b-col lg="4" cols="12" class="pb-2">
          <!-- <gradient-card :gradientCard="supportTicket" class="w-100">
            <template>
              <div class="pb-1 h3 d-flex">
                <b-skeleton width="50px" height="30px" v-if="loading" />
                <span
                  class="text-blue-ticket font-large-2 d-flex flex-column justify-content-center"
                  v-else
                  >02</span
                >
                <div class="d-flex flex-column justify-content-center pl-50">
                  <small class="d-block font-small-2">You Have</small>
                  <small class="d-block font-small-2"> New Tickets</small>
                </div>
              </div>
            </template>
          </gradient-card> -->
          <gradient-card :gradientCard="subscriptionStatus" class="w-100 h-100">
            <template slot="bottom">
              <div class="pt-1 d-flex justify-content-between">
                <div class="d-flex flex-column">
                  <span>Your current plan:</span>
                  <b-skeleton width="50px" height="30px" v-if="loading" />
                  <span v-else class="font-weight-bolder">{{
                    userData.plan 
                      ? userData.plan.name
                      : "-"
                  }}</span>
                </div>
                <div class="px-2">
                  <vue-apex-charts
                    type="radialBar"
                    height="190"
                    width="150"
                    :options="supportTrackerRadialBar.chartOptions"
                    :series="supportTrackerRadialBar.series"
                  />
                </div>
              </div>
            </template>
          </gradient-card>
        </b-col>
        <b-col lg="4" cols="12" class="pb-2">
          <leatest-competition class="h-100" :loading="loading" :dashboard="dashboard" />
        </b-col>
        <b-col lg="4" cols="12" class="pb-50">
          <div v-for="(card, index) in cards" :key="index">
            <IconCard :loading="loading" :card="card" />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <top-participants />
        </b-col>
      </b-row>
    </section>
  </div>
</template>

<script>
import { BRow, BCol, BSkeleton } from "bootstrap-vue";
import ProfileHeader from "./DashboardHeader.vue";
import LeatestCompetition from "./LeatestCompetition.vue";
import TopParticipants from "./TopParticipants.vue";
import GradientCard from "./GradientCard.vue";
import IconCard from "./IconCard.vue";
import VueApexCharts from "vue-apexcharts";
import { $themeColors } from "@themeConfig";
let moment = require("jalali-moment");
export default {
  components: {
    BRow,
    IconCard,
    BCol,
    BSkeleton,
    ProfileHeader,
    LeatestCompetition,
    TopParticipants,
    GradientCard,
    VueApexCharts,
  },

  data() {
    return {
      loading: false,
      dashboard: {},
      gradientCards: [
        {
          title: "Create Your Competition",
          icon: "CheckSquareIcon",
          content:
            "Invite Your Audience To Take Part In A Competitive Trading Environment Where They Can Show Their Skills, And Get Rewarded In Return.",
          buttonLabel: "Start",
          color: "bg-balance",
          url: "create-competition",
        },
        {
          title: "Competition Mangement",
          icon: "AwardIcon",
          content:
            "You Can Edit your Competitons, Change Allocated Awards, See Participants And Everything Else That You Need to Hold An Hold An Exciting And Fair Environment To complete in.",
          buttonLabel: "Manage",
          color: "bg-total-won",
          url: "competitions",
        },
        {
          title: "Your Wallet",
          icon: "CheckSquareIcon",
          content: "Deposit, Withdraw And See Your Full Transaction History.",
          buttonLabel: "More ",
          color: "bg-total-lost",
          url: "wallet-overview",
        },
      ],
      // supportTicket: {
      //   title: "Support Tickets",
      //   icon: "MailIcon",
      //   buttonLabel: "Respond",
      //   color: "bg-competitions-count",
      // },
      subscriptionStatus: {
        title: "Subscription Status",
        icon: "ZapIcon",
        content:
          "Check Out The Full List Of Plans And Find The One That Is Most Suitable For Your Business",
        buttonLabel: "Plans",
        color: "bg-subscription-status",
        url: "plans",
      },
      cards: [
        {
          title: "Earnings",
          value: "",
          chart: "Chart-pie-alt-partner.png",
          color: "color:#1BC1BA",
        },
        {
          title: "Money Spent",
          value: "",
          chart: "Battery-low-partner.png",
          color: "color:#FA4B68",
        },
        {
          title: "Total Participants",
          value: "",
          chart: "User-partner.png",
          color: "color:#FFFFFF",
        },
        {
          title: "Competitions held",
          value: "",
          chart: "Gamepad-partner.png",
          color: "color:#FFFFFF",
        },
      ],
    };
  },
  computed: {
    userData() {
      return (
        this.$store.state.auth.userData ||
        JSON.parse(localStorage.getItem("userData"))
      );
    },
    supportTrackerRadialBar() {
      let total = 0;
      let daysLeft = 0;
      let serie = 100;
      if (
        this.userData.plan &&
        this.userData.plan.ended_at &&
        this.userData.plan.started_at
      ) {
        total = moment(this.userData.plan.ended_at).diff(
          this.userData.plan.started_at,
          "days"
        );
      }
      if (
        this.userData.plan &&
        this.userData.plan.ended_at
      ) {
        daysLeft = moment(this.userData.plan.ended_at).diff(
          moment(),
          "days"
        );
      }
      if (total && daysLeft) {
        serie = (daysLeft / total) * 100;
      }
      return {
        series: [serie],
        chartOptions: {
          plotOptions: {
            radialBar: {
              size: 150,
              offsetY: 20,
              startAngle: -150,
              endAngle: 150,
              hollow: {
                size: "65%",
              },
              track: {
                background: "#21212C",
                strokeWidth: "100%",
              },
              dataLabels: {
                name: {
                  offsetY: 0,
                  color: $themeColors.light,
                  fontSize: "1rem",
                },
                value: {
                  show: false,
                },
              },
            },
          },
          colors: ["#73747E"],
          fill: {
            type: "gradient",
            gradient: {
              shade: "dark",
              type: "horizontal",
              shadeIntensity: 2,
              gradientToColors: ["#73747E"],
              inverseColors: true,
              opacityFrom: 3,
              opacityTo: 1,
              stops: [0, total],
            },
          },

          labels: [`${daysLeft} days left`],
        },
      };
    },
  },
  created() {
    this.getDashboard();
    if (
      !this.userData.verified &&
      this.userData.plan &&
      Object.keys(this.userData.plan).length
    ) {
      this.$swal({
        icon: "info",
        title: "Your documents are being reviewed",
      });
    }
    if (
      !(this.userData.status == "ACCEPTED" || this.userData.status == "ACTIVE")
    ) {
      this.$swal({
        icon: "warning",
        title: "You are not permmited to use our services",
      });
    }
  },
  methods: {
    async getDashboard() {
      this.loading = true;
      try {
        const { data } = await this.$http.get("/panel/dashboard/partner");
        this.dashboard = data;
        this.cards.forEach((card) => {
          card.value =
            card.title == "Earnings"
              ? "$" +
                (this.dashboard.total_deposit + this.dashboard.total_withdraw)
              : card.title == "Money Spent"
              ? "$" + this.dashboard.total_withdraw * -1
              : card.title == "Total Participants"
              ? "#" + this.dashboard.participants_count
              : card.title == "Competitions held"
              ? "#" + this.dashboard.competitions_held_count
              : "";
        });
      } catch (err) {}
      this.loading = false;
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-profile.scss";
@import "@core/scss/vue/libs/chart-apex.scss";
</style>
